module.exports = "//static.hsappstatic.net/LoginUI/static-1.15643/img/google-logo.png"